import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/routes';

const SpecLink = ({ uriFragment, children }) => {
    const trimmedUriFragment = useMemo(() => {
        let trimmed = uriFragment ? uriFragment.trim() : "";

        if (trimmed[0] !== "#") {
            trimmed = "#" + trimmed;
        }

        return trimmed;
    }, [uriFragment])

    return <Link to={routes.api.spec + trimmedUriFragment}>{children}</Link>
}

export default SpecLink;